<script>
    import { onMount } from 'svelte';
    onMount(async () => {
            var input = document.getElementById("number");

        input.addEventListener('keyup', function(e) {
            var n = 100;
            for (let i = 0; i < n; i++) { 
                this.value = this.value.replace(" ", '');
                this.value = this.value.replace("(", '');
                this.value = this.value.replace(")", '');
                this.value = this.value.replace("-", '');
                this.value = this.value.replace("a", '');
                this.value = this.value.replace("b", '');
                this.value = this.value.replace("c", '');
                this.value = this.value.replace("d", '');
                this.value = this.value.replace("e", '');
                this.value = this.value.replace("f", '');
                this.value = this.value.replace("g", '');
                this.value = this.value.replace("h", '');
                this.value = this.value.replace("i", '');
                this.value = this.value.replace("j", '');
                this.value = this.value.replace("k", '');
                this.value = this.value.replace("l", '');
                this.value = this.value.replace("m", '');
                this.value = this.value.replace("n", '');
                this.value = this.value.replace("o", '');
                this.value = this.value.replace("p", '');
                this.value = this.value.replace("q", '');
                this.value = this.value.replace("r", '');
                this.value = this.value.replace("s", '');
                this.value = this.value.replace("t", '');
                this.value = this.value.replace("u", '');
                this.value = this.value.replace("v", '');
                this.value = this.value.replace("w", '');
                this.value = this.value.replace("x", '');
                this.value = this.value.replace("y", '');
                this.value = this.value.replace("z", '');
                this.value = this.value.replace("A", '');
                this.value = this.value.replace("B", '');
                this.value = this.value.replace("C", '');
                this.value = this.value.replace("D", '');
                this.value = this.value.replace("E", '');
                this.value = this.value.replace("F", '');
                this.value = this.value.replace("G", '');
                this.value = this.value.replace("H", '');
                this.value = this.value.replace("I", '');
                this.value = this.value.replace("J", '');
                this.value = this.value.replace("K", '');
                this.value = this.value.replace("L", '');
                this.value = this.value.replace("M", '');
                this.value = this.value.replace("N", '');
                this.value = this.value.replace("O", '');
                this.value = this.value.replace("P", '');
                this.value = this.value.replace("Q", '');
                this.value = this.value.replace("R", '');
                this.value = this.value.replace("S", '');
                this.value = this.value.replace("T", '');
                this.value = this.value.replace("U", '');
                this.value = this.value.replace("V", '');
                this.value = this.value.replace("W", '');
                this.value = this.value.replace("X", '');
                this.value = this.value.replace("Y", '');
                this.value = this.value.replace("Z", '');
                this.value = this.value.replace(".", '');
            }
        });
    });
</script>

<div class="form-container">
    <div class="box mt-6 mb-6">
        <form method="post" action="https://us-central1-sms-system-853de.cloudfunctions.net/optInForm">
            <h3 class="is-size-3 mb-3">NexGen Messaging</h3>
            <p class="mb-3">Whether we have some encouragement to offer, an opportunity to meet up and hang out with fellow friends, info and updates, or the links to join our Tuesday Zoom calls, we would love to make sure you are included.</p>
            <div class="field">
                <label class="label">Contact Full Name</label>
                <div class="control">
                    <input id="name" name="name" class="input" type="text" placeholder="..." required>
                </div>
            </div>
            <div class="field">
                <label class="label">Contact Phone Number (Please add "+1" to the beginning of your number)</label>
                <div class="control">
                    <input id="number" name="number" class="input" type="text" placeholder="+155555555555" pattern=".&#123;12,15}" required>
                </div>
            </div>
            <div class="field">
                <label class="label">Terms and conditions</label>
                <label class="checkbox">
                    <input type="checkbox" name="agree" required>
                    I agree to receive promotional messages sent via an autodialer, and this agreement isn't a condition of any purchase. I also agree to the <a href="https://sms.jfv.one/terms-of-use.pdf" target="_blank">Terms of Use</a> and <a href="https://sms.jfv.one/privacy-policy.pdf" target="_blank">Privacy Policy</a>. Messages will be sent by NexGen, powered by Destiny Global. Messages will be sent from the number +1 (320) 363-9436. We will send you no more than 10 messages per month. Message and data rates may apply. You may unsubscribe at any time by texting the word STOP. Text HELP for help.
                </label>
            </div>
            <div class="control">
                <button class="button has-background-info has-text-white" type="submit">Submit</button>
            </div>
        </form>
    </div>
</div>

<style>
    .form-container {
        max-width: 500px;
        margin-left: auto;
        margin-right: auto;
        display: block;
    }

</style>